<template lang="pug">
.videoPlayerContainer
  video-player.video-player.vjs-custom-skin.vjs-16-9(ref="videoPlayer", :playsinline="false", :options="playerOptions", @timeupdate="timeupdate", @loadeddata="onPlayerLoadeddata($event)")
</template>

<script>
// 引入样式
import { scanUrl, creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import Vue from "vue";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import hls from "videojs-contrib-hls";
Vue.use(hls);
Vue.use(VideoPlayer);

export default {
  data() {
    return {
      inputText: "",
      playTime: {
        currentDuration: 0,
        totalDuration: 0,
        fileId: ""
      },
      currentTime: "", // 上一次播放进度
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        preferFullWindow: true,
        muted: false,
        loop: false,
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        src: "",
        sources: [
          {
            type: "",
            src: ""
          }
        ],
        notSupportedMessage: "此视频暂时无法播放",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        },
        html5: {
          hls: {
            withCredentials: false
          }
        }
      },
      MP4: {
        type: "video/mp4",
        src: ""
      },
      HLS: {
        type: "application/x-mpegURL",
        src: ""
      }
    };
  },

  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    },
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  beforeMount() {
    this.getFileInfo();
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      this.playTime.fileId = fileId;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await this.getRequestData(sharerId);
    },
    async getRequestData(sharerId) {
      const otherData = this.docmentData;
      // const res = await mongeService.queryHlsUrl(otherData.fileId);
      // if (Number(res.data) === 1) {
      this.playerOptions.sources[0].type = this.MP4.type;
      this.playerOptions.sources[0].src = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      // } else {
      //   this.playerOptions.sources[0].type = this.HLS.type;
      //   console.log(scanHlsUrl(res.data), 'scanHlsUrl');
      //   this.playerOptions.sources[0].src = scanHlsUrl(res.data);
      // }
      // 加水印
      addWaterMarker(document.body, creatWatermarkUserInfo());
      this.$refs.videoPlayer.player.play();
    },
    timeupdate(player) {
      this.playTime.currentDuration = player.cache_.currentTime;
      this.playTime.totalDuration = player.cache_.duration;
    },

    onPlayerLoadeddata(player) {
      this.playTime.totalDuration = player.cache_.duration;
      const { progress } = this.$route.query;
      if (!progress) return;
      let currentDuration = player.cache_.duration * (progress / 100);
      if (isNaN(currentDuration)) return;
      if (currentDuration >= player.cache_.duration) currentDuration = 0;
      this.playTime.currentDuration = currentDuration;
      player.currentTime(this.playTime.currentDuration);
    }
  }
};
</script>

<style lang="scss" scoped>
.videoPlayerContainer {
  background-color: #ccc;
  width: 100vw;
  overflow: auto;
}
</style>

